export const firebaseConfig = {
    apiKey: "AIzaSyD2MmbJOstJaF7jGLI6drDQYowhz3I2EO0",
    authDomain: "teamops-act.firebaseapp.com",
    databaseURL: "https://teamops-act-default-rtdb.firebaseio.com",
    projectId: "teamops-act",
    storageBucket: "teamops-act.firebasestorage.app",
    messagingSenderId: "248523335530",
    appId: "1:248523335530:web:c930f9968c45052f5ca713"
};
